// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Fv73","rootSmall":"AddTileButton_rootSmall__3XUIm"};